export const SET_ENTITIES = 'SET_ENTITIES';
export const SET_ENTITY = 'SET_ENTITY';
export const ADD_ENTITY = 'ADD_ENTITY';
export const UPDATE_ENTITY = 'UPDATE_ENTITY';
export const REMOVE_ENTITY = 'REMOVE_ENTITY';
export const CLEAR_ENTITY = 'CLEAR_ENTITY';
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES';
